// removed by extract-text-webpack-plugin
module.exports = {"project-details":"_1sCwcwRu","projectDetails":"_1sCwcwRu","carousel":"_mpU4DQ9","hero-image":"_38CbqjbN","heroImage":"_38CbqjbN","copy":"e4RNO7Xz","section":"_1F0BhmZL","headline":"_23joVm0v","company":"H7zl7JCC","name":"_9ulhL-zP","link-icon":"_3ZOw-3bH","linkIcon":"_3ZOw-3bH","date":"xRMfcDmD","description":"_3bf1FhC7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetails/ProjectDetails.pcss
// module id = 783
// module chunks = 0